import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bar-chart-widget',
  templateUrl: './bar-chart-widget.component.html',
  styleUrls: ['./bar-chart-widget.component.css']
})
export class BarChartWidgetComponent implements OnInit {

  constructor() { }

  @Input() parameters:object = null;
  ngOnInit() {
  }

}
